
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import Modal from '@/components/ui/Modal.vue';
import GenericTable from '@/components/tables/GenericTable.vue';
import { Session, Theme } from '@/types';
import { useStore } from '@/plugins/store';

export default defineComponent({
    components: { Modal, GenericTable },
    props: {
        selectedThemeId: {
            type: String as () => string | null,
            default: null,
        },
        selectedCourse: {
            type: Object as () => {
                id: string;
                title: string;
                percentageEnded: number;
                started: number;
                ended: number;
                themesWithSessions: { [key: string]: { session: Session; theme: Theme; statistics: { completed: number; skipped: number; unhandled: number } } };
                [key: string]: any;
            } | null,
            default: null,
        },
    },
    data() {
        return {
            headers: [
                {
                    headerName: 'Session',
                    field: 'sessionName',
                    sortable: true,
                },
                {
                    headerName: 'Fuldførte',
                    field: 'completed',
                    sortable: true,
                },
                {
                    headerName: 'Fravalgt',
                    field: 'skipped',
                    sortable: true,
                },
                {
                    headerName: 'Ikke nået til',
                    field: 'unhandled',
                    sortable: true,
                },
            ],
        };
    },
    computed: {
        ...mapState(useStore, ['themes']),
        activeTheme() {
            if (!this.$props.selectedThemeId || !this.themes) {
                return null;
            }
            return this.themes?.find((currentTheme) => currentTheme.id === this.$props.selectedThemeId);
        },
        items() {
            if (!this.$props.selectedCourse || !this.$props.selectedThemeId) {
                return [];
            }

            return Object.keys(this.$props.selectedCourse.themesWithSessions)
                .filter((currentKey) => currentKey.startsWith(this.$props.selectedThemeId!))
                .map((currentThemeWithSessions) => {
                    return {
                        sessionName: this.selectedCourse!.themesWithSessions[currentThemeWithSessions].session.title,
                        completed: this.selectedCourse!.themesWithSessions[currentThemeWithSessions].statistics.completed,
                        skipped: this.selectedCourse!.themesWithSessions[currentThemeWithSessions].statistics.skipped,
                        unhandled: this.selectedCourse!.themesWithSessions[currentThemeWithSessions].statistics.unhandled,
                    };
                });
        },
    },
});
